import { render } from "./expanding-content.vue?vue&type=template&id=151d7c94"
import script from "./expanding-content.vue?vue&type=script&lang=js"
export * from "./expanding-content.vue?vue&type=script&lang=js"

import "./expanding-content.vue?vue&type=style&index=0&id=151d7c94&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__